import styled from 'styled-components'
import Breakpoint from '../../utils/breakpoint'

const {mobile, desk, xs, sm, md, lg, xl, xxl} = Breakpoint
export const Box = styled.div`
  width: 340px;
  @media (max-width: ${mobile}px) {
    width: 260px;
  }
  & img {
    width: 100%;
    height: auto;
    display: block;
    filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.4));
  }
`
export const BoxWrapper = styled.div`
  display: flex;
  justify-content: center;
`

//
// export const LoadingBox = styled.div`
//   padding-top: 25px;
//   padding-bottom: 25px;
// `
//
// export const WidthBox = styled(Box)`
//   width: ${({ratio}) => `${ratio * 100}%`};
// `
